const ge = (a, b) => a >= b;
export default ge;
